import React, { useState, useEffect, forwardRef } from "react";
import ttAPI from '../../api/ttAPI';
import { Paper } from "@material-ui/core";
import { ViewState, GroupingState, IntegratedGrouping/*, IntegratedEditing*/ } from '@devexpress/dx-react-scheduler';
import {
  Scheduler,
  WeekView,
  Appointments,
  AppointmentTooltip,
  AppointmentForm,
  Toolbar,
  ViewSwitcher,
  /*MonthView,
  DayView,*/
  TodayButton,
  DateNavigator,
  //AllDayPanel,
  Resources,
  GroupingPanel,
  //DragDropProvider
} from '@devexpress/dx-react-scheduler-material-ui';

// components
import PageTitle from "../../components/PageTitle";
import useStyles from './styles';

const Workers = forwardRef((props, ref) => {

  // local
  var [data, setData] = useState([]);
  var [currentViewName, setCurrentViewName] = useState('work-week');
  var [isLoading, setIsLoading] = useState(false);
  const colours = ['#EF5350','#EC407A','#AB47BC','#7E57C2','#5C6BC0','#42A5F5',
                   '#29B6F6','#26C6DA','#26A69A','#66BB6A','#9CCC65','#D4E157',
                   '#FFEE58','#FFCA28','#FFCA28','#FFA726','#FF7043','#8D6E63',
                   '#BDBDBD','#78909C','#E57373','#F06292','#BA68C8','#9575CD',
                   '#7986CB','#64B5F6','#4FC3F7','#4DD0E1','#4DB6AC','#81C784',
                   '#AED581','#DCE775','#FFF176','#FFD54F','#FFB74D','#FF8A65',
                   '#A1887F','#E0E0E0','#90A4AE'];
  /*const resources = [{
    fieldName: 'worker',
    title: 'Technician',
    instances: [
      { text: 'Low Priority', id: 1, color: colours[0] },
      { text: 'High Priority', id: 2, color: colours[1] },
    ],
  }];*/
  var [resources, setResources] = useState(undefined);
  const groupOrientation = viewName => viewName.split(' ')[0];
  var [grouping, setGrouping] = useState([/*{
        resourceName: 'jobId',
      },*/{
        resourceName: 'worker',
      }]);
  var [showScheduler, setShowScheduler] = useState(false);

  const nzTime = date => (new Date(date)).toLocaleString('en-NZ', { timeZone: 'Pacific/Auckland' });

    useEffect(() => {
       let mounted = true;
       const fetchData = async() => {
         setIsLoading(true);
         const response = await ttAPI.getWorkersSchedules();
         if(mounted){
           if (response !== null && response !== undefined && response.length > 0) {
             var filteredItems = response.filter(function(r)
              {
                  return r.id !== 62560;
              });

              setData(filteredItems.map(function (workerJobSchedule) {//response.map(function (workerJobSchedule) {
                 return {
                   id: `${workerJobSchedule.id}_${workerJobSchedule.account_id}`,
                   startDate: new Date(workerJobSchedule.start),
                   endDate: new Date(workerJobSchedule.finish),
                   title: `${workerJobSchedule.id} - ${workerJobSchedule.customer_name} - ${workerJobSchedule.site_name}`,
                   worker: workerJobSchedule.name,
                   jobId: workerJobSchedule.id,
                   regionId: workerJobSchedule.job_region_id
                 };
               }));
            }
            setIsLoading(false);
         }

          //setData([{id: 1, title: 'test', startDate: "2021-01-20T10:27:10.000", endDate: "2021-01-21T18:11:04.785",}]);

       };
       if ((data === null || data === undefined || data.length === 0)
           && (props.id === undefined || props.id === null || props.id <= 0)){
          fetchData();
       }

       return () => mounted = false;

    }, []);

   useEffect(() => {
      if (data != null && data !== undefined && data.length > 0) {
        let names = data.map(({ worker }) => worker);
        let uniqueNames = [...new Set(names)];

        var resourcesInstances = [];
        var colourIndex = 0;
        uniqueNames.map(function (un, index) {
           if (colourIndex >= colours.length) {
             colourIndex = 0;
           }
           resourcesInstances[index] = {id: index, text: un, color: colours[colourIndex++]}
         });

         console.log(resourcesInstances);
        /* let jobs = data.map(({ id }) => id);
         let uniqueJobs = [...new Set(jobs)];
         var resourcesJobInstances = [];
         colourIndex = 0;
         uniqueJobs.map(function (uj, index) {
            if (colourIndex >= colours.length) {
              colourIndex = 0;
            }
            resourcesJobInstances.push({id: index, text: uj, color: colours[colourIndex++]});
          });*/



         setResources([/*{
            fieldName: 'jobId',
            title: 'Job',
            instances: resourcesJobInstances,
            allowMultiple: true,
          },*/{
           fieldName: 'worker',
           title: 'Technician',
           instances:resourcesInstances,
         allowMultiple: true,}]);
      }

    }, [data]);

useEffect(() => {
  if (resources !== undefined && resources !== null) {
    setShowScheduler(true);
  }
  else {
    setShowScheduler(false);
  }
  }, [resources]);

    function currentViewNameChange(cvn) {
        setCurrentViewName(cvn);
    }



  return (
    <>
      <PageTitle title="Workers" />
        {data !== undefined && data !== null
          && resources !== undefined && resources !== null &&
          <Paper>
      <Scheduler
        data={data}
        height={660}
      >
        <ViewState
          defaultCurrentDate={ViewState.currentDate}
        />

        <GroupingState
          grouping={grouping}
          groupOrientation={groupOrientation}
        />

        <WeekView
          startDayHour={9}
          endDayHour={17}
          excludedDays={[0, 6]}
          cellDuration={60}
          name="Vertical Orientation"
        />
        <WeekView
          startDayHour={9}
          endDayHour={17}
          excludedDays={[0, 6]}
          name="Horizontal Orientation"
        />



        <Appointments />
        <Resources
          data={resources}
          mainResourceName="worker"
        />

        <IntegratedGrouping />

        <AppointmentTooltip />
        <AppointmentForm />

        <GroupingPanel />
        <Toolbar />
        <DateNavigator />
        <TodayButton />
        <ViewSwitcher />
      </Scheduler>
    </Paper>}

{/*per job per worker,scrumbled on month view*/}
          {/*<Paper>
        <Scheduler
          data={data}
          locale="en-NZ"
        >
          <ViewState
            defaultCurrentDate={ViewState.currentDate}
          />
          <WeekView/>
          <MonthView />
          <DayView />
          <Toolbar />
          <DateNavigator />
          <TodayButton />
          <ViewSwitcher />
          <Appointments />

          <AppointmentTooltip
            showCloseButton
            showOpenButton
          />
          <AppointmentForm
            readOnly
          />

          <AllDayPanel/>

        </Scheduler>
      </Paper>*/}


      {/*grouping*/}
      {/*data !== undefined && data !== null && resources !== null && resources !== undefined && showScheduler && <Paper>
      <Scheduler
        data={data}
        locale="en-NZ"
      >
        <ViewState
          defaultCurrentDate={ViewState.currentDate}
        />
        <GroupingState grouping={grouping}/>
        <DayView
         startDayHour={7}
         endDayHour={23}
         intervalCount={2}
       />
        <Toolbar />
        <DateNavigator />
        <TodayButton />
        <Appointments />
        <Resources
          data={resources}
          mainResourceName="worker"
        />
        <IntegratedGrouping />
        <AppointmentTooltip
          showCloseButton
          showOpenButton
        />
        <AppointmentForm
          readOnly
        />
         <GroupingPanel />

        <AllDayPanel/>

      </Scheduler>
    </Paper>*/}
    </>
  );
});

export default Workers;
